import { render, staticRenderFns } from "./AdminEstoque.vue?vue&type=template&id=ce6a16bc&scoped=true"
import script from "./AdminEstoque.vue?vue&type=script&lang=js"
export * from "./AdminEstoque.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=ce6a16bc&prod&scoped=true&lang=css&external"
import style1 from "./AdminEstoque.vue?vue&type=style&index=1&id=ce6a16bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6a16bc",
  null
  
)

export default component.exports